module.exports = "::ng-deep .alert p {\n  margin-bottom: 0; }\n"